import service from '@/store/services/adminAppConfig-service';

const state = {
    actualAppConfig: {},
    updateAppVersion: {},
    updateDelayTime: {},
    updateOrderPageDefaultForAll: {},
    updateOrderCacheLogValue: {},
    updateLowRecaptchaIpsValue: {},
    updateSendUpdateNotif: {},
    updateDelayOptions: {},
    checkAdminPassword: {}
};

const mutations = {
    SET_ACTUAL_APP_CONFIG: (state, actualAppConfig) => {
        state.actualAppConfig = actualAppConfig;
    },
    SET_UPDATE_APP_VERSION: (state, updateAppVersion) => {
        state.updateAppVersion = updateAppVersion;
    },
    SET_UPDATE_DELAY_TIME: (state, updateDelayTime) => {
        state.updateDelayTime = updateDelayTime;
    },
    SET_UPDATE_ORDER_PAGE_DEFAULT_FOR_ALL: (state, updateOrderPageDefaultForAll) => {
        state.updateOrderPageDefaultForAll = updateOrderPageDefaultForAll;
    },
    SET_UPDATE_ORDER_CACHE_LOG: (state, updateOrderCacheLogValue) => {
        state.updateOrderCacheLogValue = updateOrderCacheLogValue;
    },
    SET_UPDATE_LOW_RECAPTCHA_IPS: (state, updateLowRecaptchaIpsValue) => {
        state.updateLowRecaptchaIpsValue = updateLowRecaptchaIpsValue;
    },
    SET_UPDATE_SEND_NOTIF: (state, updateSendUpdateNotif) => {
        state.updateSendUpdateNotif = updateSendUpdateNotif;
    },
    SET_UPDATE_DELAY_OPTIONS: (state, updateDelayOptions) => {
        state.updateDelayOptions = updateDelayOptions;
    },
    CHECK_ADMIN_PASSWORD: (state, checkAdminPassword) => {
        state.checkAdminPassword = checkAdminPassword;
    }
};

const actions = {
    actualAppConfig({commit, dispatch}, params) {
        return service.actualAppConfig(params)
            .then(({actualAppConfig}) => {
                commit('SET_ACTUAL_APP_CONFIG', actualAppConfig);
            });
    },
    updateAppVersion({commit, dispatch}, params) {
        return service.updateAppVersion(params).then((updateAppVersion) => {
            commit('SET_UPDATE_APP_VERSION', updateAppVersion);
        });
    },
    updateDelayTime({commit, dispatch}, params) {
        return service.updateDelayTime(params).then((updateDelayTime) => {
            commit('SET_UPDATE_DELAY_TIME', updateDelayTime);
        });
    },
    updateOrderPageDefaultForAll({commit, dispatch}, params) {
        return service.updateOrderPageDefaultForAll(params).then((updateOrderPageDefaultForAll) => {
            commit('SET_UPDATE_ORDER_PAGE_DEFAULT_FOR_ALL', updateOrderPageDefaultForAll);
        });
    },
    updateOrderCacheLogValue({commit, dispatch}, params) {
        return service.updateOrderCacheLogValue(params).then((updateOrderCacheLogValue) => {
            commit('SET_UPDATE_ORDER_CACHE_LOG', updateOrderCacheLogValue);
        });
    },
    updateLowRecaptchaIpsValue({commit, dispatch}, params) {
        return service.updateLowRecaptchaIpsValue(params).then((updateLowRecaptchaIpsValue) => {
            commit('SET_UPDATE_LOW_RECAPTCHA_IPS', updateLowRecaptchaIpsValue);
        });
    },
    updateSendUpdateNotif({commit, dispatch}, params) {
        return service.updateSendUpdateNotif(params).then((updateSendUpdateNotif) => {
            commit('SET_UPDATE_SEND_NOTIF', updateSendUpdateNotif);
        });
    },
    updateDelayOptions({commit, dispatch}, params) {
        return service.updateDelayOptions(params).then((updateDelayOptions) => {
            commit('SET_UPDATE_DELAY_OPTIONS', updateDelayOptions);
        });
    },
    checkAdminPassword({commit, dispatch}, params) {
        return service.checkAdminPassword(params).then((checkAdminPassword) => {
            commit('CHECK_ADMIN_PASSWORD', checkAdminPassword);
        });
    },
};

const getters = {
    actualAppConfig: state => state.actualAppConfig,
    updateAppVersion: state => state.updateAppVersion,
    updateDelayTime: state => state.updateDelayTime,
    updateOrderPageDefaultForAll: state => state.updateOrderPageDefaultForAll,
    updateOrderCacheLogValue: state => state.updateOrderCacheLogValue,
    updateLowRecaptchaIpsValue: state => state.updateLowRecaptchaIpsValue,
    updateSendUpdateNotif: state => state.updateSendUpdateNotif,
    updateDelayOptions: state => state.updateDelayOptions,
    checkAdminPassword: state =>  getterKey => state.checkAdminPassword,
};

const adminAppConfig = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default adminAppConfig;